// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KaDe","label":"styles_label__-1jju"};